import { useUsersAuthzCheckUserPermissionUserPermissions } from '@mi-front/api-v2';
import { UserRole } from '@mi-front/core';
import { useAuth } from '../../authentication/hooks/useAuth';

export function useHasPermission(permission: string): boolean | undefined {
  const auth = useAuth();
  const shouldCheckPermission = auth.user.role === UserRole.CLIENT_USER;

  const permissionCheck = useUsersAuthzCheckUserPermissionUserPermissions(permission, {
    query: {
      enabled: shouldCheckPermission,
    },
  });

  if (!shouldCheckPermission) {
    return true;
  }

  return permissionCheck.data?.hasPermission;
}
